import CryptoJS from 'crypto-js';
const secret = 'mobility<>Refex$in';  
const key = CryptoJS.SHA256(secret); 
export function decrypt(encrypted) {
  if (!encrypted) return '';
  try {
    const [ivBase64, encryptedBase64] = decodeURIComponent(encrypted).split(':');
    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const encryptedData = CryptoJS.enc.Base64.parse(encryptedBase64);
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData },
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error('Decryption failed:', err);
    return '';
  }
}
